module.exports = "/_next/static/images/refund_desktop-995278f57e14941078beb4512ec1c024.svg";